export function Header() {
  return (
    <header className="brand">
      <div className="brand-mark">
        R<em>594</em>
      </div>
      <div className="brand-name">
        Risk<em>594</em>
      </div>
    </header>
  );
}
